export default __webpack_public_path__ + "static/media/Request.8f5bfd12.graphql";